import Navbar from "@/components/sections/Navbar";
import Hero from "@/components/sections/Hero";
import Occasions from "@/components/sections/Occasions";
import SplitFeatures from "@/components/sections/SplitFeatures";
import WhyMemoire from "@/components/sections/WhyMemoire";
import NoCamera from "@/components/sections/NoCamera";
import GetStartedCTA from "@/components/sections/GetStartedCTA";
import Footer from "@/components/sections/Footer";
import ComingSoonOverlay from "@/components/ComingSoonOverlay";
import { Toaster } from "sonner";

export default function Landing() {
  return (
    <div className="min-h-screen bg-white text-neutral-900">
      <Navbar />
      <main>
        <Hero />
        <Occasions />
        <SplitFeatures />
        <WhyMemoire />
        <NoCamera />
        <GetStartedCTA />
      </main>
      <Footer />
      {/* Remove the line below to disable the "Coming Soon" popup */}
      <ComingSoonOverlay />
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            borderRadius: "9999px",
            padding: "10px 20px",
            fontFamily: "DM Sans, sans-serif",
          },
        }}
      />
    </div>
  );
}
